import { render } from "./CalculatorComponent.vue?vue&type=template&id=70622f9f&scoped=true"
import script from "./CalculatorComponent.vue?vue&type=script&lang=js"
export * from "./CalculatorComponent.vue?vue&type=script&lang=js"

import "./CalculatorComponent.vue?vue&type=style&index=0&id=70622f9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70622f9f"]])

export default __exports__